import InputRangeDate from './InputRangeDate'

export default InputRangeDate
